export const BREADCRUMB_NAME_MAP: Record<string, string> = {
  acoes: 'Ações',
  ajuda: 'Ajuda',
  atuacoes: 'Atuações',
  colaboradores: 'Colaboradores',
  comarcas: 'Comarcas',
  configuracoes: 'Configurações',
  defensor: 'Defensor',
  distrito: 'Distrito',
  estagiario: 'Estagiários',
  feriados: 'Bloqueios',
  folhas: 'Folhas de Frequência',
  folha_frequencia: 'Folhas de Frequência',
  'folha-frequencia': 'Folha de Frequência',
  pendencias: 'Pendências',
  'minhas-folhas': 'Minhas Folhas',
  'folha-atual': 'Folha Atual',
  instituicoes: 'Instituições',
  pessoa: 'Cadastros de pessoas',
  aniversarios: 'Aniversários',
  nucleo: 'Núcleo',
  relatorios: 'Relatórios',
  criar: 'Criar relatório',
  meus: 'Meus relatórios',
  corregedoria: 'Corregedoria',
  aprovacao: 'Diretoria Regional',
  solar: 'Solar',
  atendimentos: 'Atendimentos',
  defensores: 'Defensores',
  estagiarios: 'Estagiários',
  ferias: 'Férias',
  lotacoes: 'Lotações',
  publico: 'Público',
  nucleos: 'Núcleos',
  movimentacoes: 'Movimentações',
  sessoes: 'Sessões',
  usuario: 'Usuários',
  varas: 'Varas',
  vinculos: 'Vínculos',
  vinculos_colaborador: 'Vínculos',
  vinculos_defensor: 'Vínculos',
  vinculos_estagio: 'Vínculos',
  'gestao-arquivos': 'Gestão de Arquivos',
  'processo-seletivo': 'Processos seletivos',
  candidatos: 'Candidatos',
  candidato: 'Candidato',
  analises: 'Análises',
  auditorias: 'Auditorias',
};

export const VINCULOS_REDIRECT_SEGMENTS = [
  'vinculos_defensor',
  'vinculos_colaborador',
  'vinculos_estagio',
];

export function getBreadcrumbLabel(segment: string): string {
  return BREADCRUMB_NAME_MAP[segment] || segment;
}
